const defaultState = {
  isAddNew: '',  // control based on score is NULL or not
  score: {
    gc: '',
    id: '',
    si: '',
    dt_g: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    dt_b: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  },
  school_dt: {
    res: '-1',      // control 0 is not found or invalid school code
    scod: '',
    schENG: '',
    schKH: '',
    proENG: '',
    proKH: '',
    disENG: '',
    disKH: '',
    comENG: '',
    comKH: '',
    fid: '',      // forign key ID
    type_code: '',
    g1: '',
    g2: '',
    g3: '',
    g4: '',
    g5: '',
    g6: '',
    pho_num: '',  // telephone number
    sco_g1: [], // if score is NULL-->insert data else -->Update data
    sco_g2: [],
    sco_g3: [],
    sco_g4: [],
    sco_g5: [],
    sco_g6: []
  }
}

export default defaultState
